<template>
  <div class="headermax_wrapper">
    <navCom class="navCom_po" @headerHeight="headerHeight"></navCom>
    <div class="PC_wrap">
      <el-carousel trigger="click" :height="heightValue">
        <el-carousel-item v-for="item in 4" :key="item">
          <div
            v-if="PagesUrl == '/home'"
            class="header_banner"
            :style="`background-image: url(${bgImgUrl})`"
          >
            <div class="text_max">服务好每一位客户</div>
            <div class="text_mid">
              <span>鉴证优秀 成就卓越</span>
              <span>助力客户价值提升是我们矢志不移的追求目标</span>
            </div>
            <div class="header_more">
              了解更多<img src="../assets/home/red_right.png" alt="" />
            </div>
          </div>
          <div
            v-else
            class="header_banner banner_two"
            :style="`background-image: url(${bgImgUrl})`"
          >
            <div class="text_max">{{ textTop }}</div>
            <div class="text_mid">
              <span>{{ textBtm }}</span>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="phone_wrap">
      <el-carousel trigger="click" :height="phHeightValue">
        <el-carousel-item v-for="item in 4" :key="item">
          <div v-if="PagesUrl == '/home'" class="header_banner">
            <img class="banner_bg" :src="bgImgUrl" alt="" />
            <div class="text_max">服务好每一位客户</div>
            <div class="text_mid">
              <span>鉴证优秀 成就卓越</span>
              <span>助力客户价值提升是我们矢志不移的追求目标</span>
            </div>
            <div class="header_more">
              了解更多<img src="../assets/home/red_right.png" alt="" />
            </div>
          </div>
          <div
            v-else
            class="header_banner banner_two"
            :style="`background-image: url(${bgImgUrl});height: ${phHeightValue}`"
          >
            <div class="text_max">{{ textTop }}</div>
            <div class="text_mid">
              <span>{{ textBtm }}</span>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import navCom from "@/components/navCom.vue";
export default {
  components: {
    navCom,
  },
  data() {
    return {
      heightValue: "850px",
      phHeightValue: "180px",
      bgImgUrl: require("../assets/home_banner.png"),
      PagesUrl: "/home",
      textTop: "关于我们",
      textBtm: "了解更多越华资讯",
    };
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    headerHeight(num) {
      console.log(num, "组件传参");
      this.heightValue = num.heigth;
      console.log(this.heightValue);
      this.PagesUrl = num.indexKey;
      if (num.indexKey == "/home") {
        this.bgImgUrl = require("../assets/home_banner.png");
        this.phHeightValue = "180px";
      } else if (num.indexKey == "/about") {
        this.textTop = "关于我们";
        this.textBtm = "了解更多越华资讯";
        this.bgImgUrl = require("../assets/about_banner.png");
        this.phHeightValue = "140px";
      } else if (num.indexKey == "/contact") {
        this.textTop = "联系我们";
        this.textBtm = "欢迎您的来电咨询";
        this.bgImgUrl = require("../assets/contact_banner.png");
        this.phHeightValue = "140px";
      } else if (num.indexKey == "/news" || num.indexKey == "/details") {
        this.textTop = "新闻资讯";
        this.textBtm = "了解更多越华资讯";
        this.bgImgUrl = require("../assets/news_banner.png");
        this.phHeightValue = "140px";
      } else {
        this.textTop = "产品中心";
        this.textBtm = "精益品质，匠心智造";
        this.bgImgUrl = require("../assets/products_banner1.png");
        this.phHeightValue = "150px";
      }
    },
    handleResize() {
      console.log(window.innerWidth);
    },
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="less" scoped>
// PC端
@media screen and (min-width: 769px) {
  .headermax_wrapper {
    width: 100%;
    position: relative;
    cursor: default;

    .phone_wrap {
      display: none;
    }

    .PC_wrap {
      display: block;
    }

    .navCom_po {
      position: absolute;
      top: 24px;
      left: 0;
      z-index: 9;
    }

    .header_banner {
      height: 100%;
      width: 100vw;

      // background-image: url("../assets/home_banner.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .text_max {
        margin-left: 400px;
        font-size: 50px;
        font-weight: bold;
        color: #ffffff;
      }

      .text_mid {
        margin: 46px 0 70px 400px;
        display: flex;
        flex-direction: column;
        font-size: 23px;
      }

      .header_more {
        margin-left: 400px;
        width: 218px;
        height: 48px;
        border: 2px solid #cecece;
        border-radius: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 40px;
        cursor: pointer;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }

    .banner_two {
      align-items: center;

      .text_max {
        margin-left: 0;
      }

      .text_mid {
        margin: 46px 0 0 0;
      }
    }
  }
}

// 移动端
@media screen and (max-width: 768px) {
  .headermax_wrapper {
    width: 100vw;
    position: relative;

    .PC_wrap {
      display: none;
    }

    .phone_wrap {
      display: block;
    }

    .navCom_po {
      position: absolute;
      top: 24px;
      left: 0;
      z-index: 9;
    }

    .header_banner {
      position: relative;
      width: 100vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 10px;
      color: #ffffff;
      background-size: 100% 100%;
      background-repeat: no-repeat;

      .banner_bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }

      .text_max {
        z-index: 99;
        font-size: 10px;
        font-weight: bold;
        padding-top: 50px;
      }

      .text_mid {
        display: flex;
        flex-direction: column;
        z-index: 99;
        font-size: 10px;
        margin: 20px 0;
      }

      .header_more {
        z-index: 99;
        font-size: 13px;
        border: 2px solid #cecece;
        border-radius: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px 10px;
        box-sizing: border-box;

        img {
          width: 15px;
          height: 15px;
          margin-left: 20px;
        }
      }
    }

    .banner_two {
      align-items: center;

      .text_max {
        padding-top: 2px;
        margin-left: 0;
      }

      .text_mid {
        margin: 10px 0 0 0;
      }
    }
  }
}
</style>
